import { SET_DESTINATIONS } from "../actionTypes";

const initialState = {
  loaded: false,
  destinations: {},
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_DESTINATIONS: {
      const { data } = action.payload;
      return {
        ...state,
        loaded: true,
        destinations: data
      }
    }
    default:
      return state;
  }
}
